import { render } from "./lotInfoCurrentValue.vue?vue&type=template&id=8ed78f98"
import script from "./lotInfoCurrentValue.vue?vue&type=script&lang=ts"
export * from "./lotInfoCurrentValue.vue?vue&type=script&lang=ts"
script.render = render

export default script